import { ErrorMessage } from '@hookform/error-message';
import { ReactNode } from 'react';
import { Form } from 'react-bootstrap';
import { Control, FieldPathByValue, FieldValues, useController } from 'react-hook-form';

import { Hint } from '../Hint';
import { RichTextEditor } from './RichTextEditor';

type Props<T extends FieldValues> = {
  fieldName: FieldPathByValue<T, string | undefined>;
  control: Control<T>;
  hideErrorMessage?: boolean;
  label?: ReactNode;
  placeholder?: string;
  hint?: ReactNode;
  required?: boolean;
};

export function ControlledRichTextEditor<T extends FieldValues>({
  control,
  fieldName,
  hideErrorMessage = false,
  label,
  placeholder,
  hint,
  required,
}: Props<T>) {
  const {
    field: { onChange, value },
    formState: { errors },
  } = useController({ control, name: fieldName });

  return (
    <>
      {label && (
        <Form.Label className="u-fs-2 fw-bold">
          {label}
          {required && <span className="u-color-red1 ps-1 ">*</span>}
        </Form.Label>
      )}
      <RichTextEditor placeholder={placeholder} value={value} onChange={onChange} />
      {hint && <Hint>{hint}</Hint>}
      {!hideErrorMessage && (
        <ErrorMessage
          errors={errors}
          name={fieldName as any}
          render={({ message }) => <div className="u-fs-2 u-color-red1">{message}</div>}
        />
      )}
    </>
  );
}
